module.exports = __webpack_public_path__ + "img/_4.ca82a48c.png";